import { c as _c } from "react/compiler-runtime";
import { postOrgPlaybooksEditSessionsByEditSessionIdRestoreMutation } from '@onefootprint/fetch-dashboard';
import { useMutation } from '@tanstack/react-query';
import { useStore } from '@/components/playbook-builder';
import { GraphUndoRedo } from './graph-undo-redo';
export const GraphUndoRedoContainer = () => {
  const $ = _c(10);
  const store = useStore();
  const {
    history,
    sessionId,
    graph
  } = store.data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = postOrgPlaybooksEditSessionsByEditSessionIdRestoreMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const restoreMutation = useMutation(t0);
  let t1;
  if ($[1] !== graph || $[2] !== restoreMutation || $[3] !== sessionId || $[4] !== store) {
    t1 = async logId => {
      if (!sessionId) {
        throw Error("Can not save graph without an active edit session.");
      }
      const response = await restoreMutation.mutateAsync({
        path: {
          editSessionId: sessionId
        },
        body: {
          expectedLastGraphId: graph.id,
          id: logId
        }
      });
      store.setGraphUpdate(response);
    };
    $[1] = graph;
    $[2] = restoreMutation;
    $[3] = sessionId;
    $[4] = store;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onRestore = t1;
  let t2;
  if ($[6] !== history || $[7] !== onRestore || $[8] !== restoreMutation.isPending) {
    t2 = <GraphUndoRedo history={history} onRestore={onRestore} isPending={restoreMutation.isPending} />;
    $[6] = history;
    $[7] = onRestore;
    $[8] = restoreMutation.isPending;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};